import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import createFontFace from './createFontFace.js';
import createPreLoad from './createPreLoad.js';
import loadSecondaryFonts from './loadSecondaryFonts.js';

var __extends = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var Font =
/** @class */
function (_super) {
  __extends(Font, _super);

  function Font() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Font.prototype.componentDidMount = function () {
    var _a = this.props,
        fonts = _a.fonts,
        variants = _a.variants,
        formats = _a.formats,
        loaderConfig = _a.loaderConfig;
    loaderConfig && loadSecondaryFonts(fonts, variants, formats, loaderConfig);
  };

  Font.prototype.render = function () {
    var _a = this.props,
        container = _a.container,
        fonts = _a.fonts,
        variants = _a.variants,
        formats = _a.formats;
    return React.createElement(React.Fragment, null, ReactDOM.createPortal(React.createElement(React.Fragment, null, createPreLoad(fonts, variants, formats), createFontFace(fonts, variants, formats)), container));
  };

  return Font;
}(Component);

export default Font;
